import { Theme } from '@mui/material/styles'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { shadows } from 'c1ui/theme/C1Theme'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const tableGridHeaderStyles: moduleStyleType = {
    header: {
        borderTopLeftRadius: C1BorderRadius.large,
        borderTopRightRadius: C1BorderRadius.large,
        p: 3,
        pb: 2,
        m: 0,
        backgroundColor: 'background.default',
    },
    title: {
        display: 'flex',
        alignItems: 'center',
    },
    info: {
        mr: 2,
        display: 'inline-block',
    },
    sticker: {
        fontSize: 14,
    },
    button: {
        ml: 1,
    },
}

export const tableGridStyles: moduleStyleType = {
    tableGrid: {
        border: (theme: Theme): string => `1px solid ${theme.palette.divider}`,
        borderRadius: C1BorderRadius.large,
        mb: 4,
        boxShadow: shadows.default,
    },
    bodyDefault: {
        px: 3,
        pt: 0,
        pb: 4,
        m: 0,
    },
    bodyCompact: {
        pb: 4,
        m: 0,
    },
    bodyNoPadding: {
        p: 0,
        m: 0,
    },
    body: {
        backgroundColor: 'background.default',
        borderBottomLeftRadius: C1BorderRadius.large,
        borderBottomRightRadius: C1BorderRadius.large,
        pb: 4,
    },
}
